export function getEventDescription(eventCode: string): string {
  if (!eventCode) {
    return 'Evento Desconocido'; // o cualquier valor predeterminado que prefieras
  }

  const eventDescriptions: {[key: string]: string} = {
    'billing_process_opened': 'Apertura de Proceso de Facturación',
    'billing_process_closed': 'Cierre de Proceso de Facturación',
    'bill_sent_event': 'Evento de Factura Enviada',
    'bill_created_event': 'Evento de Factura Creada', // Nuevo valor añadido
    'provider_not_available': 'Proveedor No Disponible',
    'biller_not_available': 'Facturador No Disponible'
  };

  return eventDescriptions[eventCode] || 'Evento Desconocido';
}
